import { Box, Typography, Stack, Checkbox, Tooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const GENDERS = [
  { value: 'male', label: 'Male', setter: 'male' },
  { value: 'female', label: 'Female', setter: 'female' },
  { value: 'unknown', label: 'Unknown', setter: 'unspecified_gender' },
];

export const AuditorySelect2 = ({ handleFormChange, formState }: any) => {
  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <Typography fontWeight={600} variant="subtitle2">Аудитория:</Typography>
      <Stack direction="row" gap={0.5}>
        {GENDERS.map(gender => (
          <Box key={gender.value} display="flex" alignItems="center" gap={0.5}>
            <label>{gender.label}</label>
            <Checkbox
              value={gender.value}
              checked={
                gender.value === formState[gender.setter as 'male' | 'female' | 'unspecified_gender']
              }
              onChange={e => {
                handleFormChange(
                  gender.setter as 'male' | 'female' | 'unspecified_gender',
                  e.target.checked ? gender.value : '',
                );
              }}
            />
            {gender.value === 'unknown' && (
              <Tooltip title="Включает пользователей, чей пол не определен Google">
                <IconButton size="small">
                  <HelpOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
